<div class="relative bg-white overflow-hidden max-w-full">
  <!-- Dynamic Breadcrumb -->
  <div class="w-full px-4 sm:px-6 lg:px-8 bg-white">
    <app-breadcrum [data]="breadcrumbData" (breadcrumbClick)="onBreadcrumbClick($event)">
    </app-breadcrum>
  </div>

  <!-- Filters and Search -->
  <div class="mx-auto px-4 sm:px-6 lg:px-8 mt-2 md:mt-4 flex flex-col md:flex-row justify-between items-center gap-4">
    <!-- Filter Tabs -->
    <div class="flex bg-blue-100 rounded-lg p-2 gap-2 max-sm:w-full justify-between">
      <button class="flex-1 sm:w-24 h-8 flex items-center justify-center rounded font-bold" [ngClass]="{
          'bg-blue-600 text-white': filterType === 'all',
          'text-Text-Black': filterType !== 'all',
        }" (click)="filterTypeChange('all')">
        All
      </button>
      <button class="flex-1 sm:w-24 h-8 flex items-center justify-center rounded font-medium" [ngClass]="{
          'bg-blue-600 text-white': filterType === 'IMAGE BASED',
          'text-Text-Black': filterType !== 'IMAGE BASED',
        }" (click)="filterTypeChange('IMAGE BASED')">
        Blogs
      </button>
      <button class="flex-1 sm:w-24 h-8 flex items-center justify-center rounded font-medium" [ngClass]="{
          'bg-blue-600 text-white': filterType === 'video',
          'text-Text-Black': filterType !== 'video',
        }" (click)="filterTypeChange('video')">
        Videos
      </button>
    </div>

    <!-- Search -->
    <div class="flex gap-3 w-full md:w-auto">
      <div class="flex justify-between items-center w-full md:w-80 p-2 rounded-md border border-[#D4D4D4]">
        <input [(ngModel)]="searchQuery" (keyup.enter)="onSearch()" (input)="isSearchActive = false"
          placeholder="Search Blogs or Videos"
          class="w-full text-sm text-Text-Caption font-medium focus:outline-none" />

        <!-- Search Icon (clickable when valid) -->
        <svg *ngIf="!isSearchActive" width="20" height="20" viewBox="0 0 20 20" fill="none"
          xmlns="http://www.w3.org/2000/svg" class="shrink-0 ml-2 transition-opacity" [class.opacity-50]="!canSearch"
          [class.cursor-not-allowed]="!canSearch" [class.cursor-pointer]="canSearch" (click)="canSearch && onSearch()"
          [attr.title]="
            canSearch
              ? 'Click to search'
              : 'Enter at least 3 alphanumeric characters'
          ">
          <path
            d="M13.8807 13.8807C16.4842 11.2772 16.4842 7.05612 13.8807 4.45262C11.2772 1.84913 7.05612 1.84913 4.45262 4.45262C1.84913 7.05612 1.84913 11.2772 4.45262 13.8807C7.05612 16.4842 11.2772 16.4842 13.8807 13.8807ZM13.8807 13.8807L17.5 17.5"
            [ngStyle]="{ stroke: canSearch ? '#2563eb' : '#777777' }" stroke-width="1.66667" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>

        <!-- Clear/Remove Icon (when search is active) -->
        <svg *ngIf="isSearchActive" width="20" height="20" viewBox="0 0 20 20" fill="none"
          xmlns="http://www.w3.org/2000/svg" class="shrink-0 ml-2 cursor-pointer hover:opacity-70 transition-opacity"
          (click)="clearSearch()" title="Clear search">
          <path d="M7 7L13 13M13 7L7 13" stroke="black" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </div>

      <!-- Sort dropdown -->
      <div #sortButton
        class="flex items-center gap-1 p-2 pl-3 bg-white rounded-lg border border-[#D4D4D4] cursor-pointer"
        (click)="toggleSortDropdown()">
        <span class="hidden md:inline text-sm font-medium text-Text-Black whitespace-nowrap">{{ getSortDisplayText()
          }}</span>

        <div class="w-5 h-5">
          <div class="w-3">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
              class="sort-icon" style="width: 20px; height: 20px">
              <path d="M2 16L6 16M2 10L10 10M2 4L14 4" stroke="black" stroke-width="1.5" stroke-linecap="round"></path>
            </svg>
          </div>
        </div>
      </div>

      <div #sortDropdown *ngIf="isSortDropdownOpen"
        class="absolute mt-10 ml-[250px] z-10 bg-white rounded shadow-lg p-2 outline outline-1 outline-offset-[-1px] outline-Neutrals-Light-Grey w-44">
        <div class="px-3 py-2 hover:bg-gray-100 cursor-pointer rounded flex items-center justify-between"
          [class.bg-blue-50]="selectedSort === 'popular'" (click)="selectSortOption('popular')">
          <span>Popular</span>
          <svg *ngIf="selectedSort === 'popular'" width="16" height="16" viewBox="0 0 16 16" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M13.3333 4L6 11.3333L2.66667 8" stroke="#2563eb" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </div>
        <div class="h-px bg-Neutrals-Light-Grey my-1"></div>
        <div class="px-3 py-2 hover:bg-gray-100 cursor-pointer rounded flex items-center justify-between"
          [class.bg-blue-50]="selectedSort === 'oldToNew'" (click)="selectSortOption('oldToNew')">
          <span>Old to New</span>
          <svg *ngIf="selectedSort === 'oldToNew'" width="16" height="16" viewBox="0 0 16 16" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M13.3333 4L6 11.3333L2.66667 8" stroke="#2563eb" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </div>
        <div class="h-px bg-Neutrals-Light-Grey my-1"></div>
        <div class="px-3 py-2 hover:bg-gray-100 cursor-pointer rounded flex items-center justify-between"
          [class.bg-blue-50]="selectedSort === 'newToOld'" (click)="selectSortOption('newToOld')">
          <span>New to Old</span>
          <svg *ngIf="selectedSort === 'newToOld'" width="16" height="16" viewBox="0 0 16 16" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M13.3333 4L6 11.3333L2.66667 8" stroke="#2563eb" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </div>
      </div>
    </div>
  </div>

  <!-- Blog & Video Cards Grid -->
  <div class="mx-auto px-4 sm:px-6 mt-12 grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6"
    *ngIf="filteredItems.length > 0">
    <div *ngFor="let item of filteredItems" class="flex flex-col gap-3 sm:gap-3 cursor-pointer"
      (click)="handleCardClick(item, $event)">
      <!-- Image or Video Thumbnail -->
      <div class="relative h-40 sm:h-72 rounded-2xl overflow-hidden cursor-pointer"
        (click)="handleImageClick(item, $event)">
        <!-- Show image if available -->
        <img *ngIf="hasImage(item)" class="object-cover w-full h-full" [src]="item.images[0]" [alt]="item?.title" />

        <!-- Show placeholder if no image and no video -->
        <img *ngIf="!hasImage(item) && !hasVideo(item)" class="object-cover w-full h-full" src="assets/default.webp"
          [alt]="item?.title" />

        <!-- YouTube video thumbnail if video exists but no image -->
        <img *ngIf="!hasImage(item) && hasVideo(item)" class="object-cover w-full h-full" [src]="
            getYouTubeThumbnailUrlWithFallback(getVideoUrl(item)) ||
            'assets/default.webp'
          " [alt]="item?.title || 'Video thumbnail'" (error)="onThumbnailError($event)" />

        <!-- Video play button overlay -->
        <div *ngIf="hasVideo(item)"
          class="absolute inset-0 bg-black/30 flex items-center justify-center hover:bg-black/40 transition-all">
          <div
            class="w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 bg-transparent rounded-full flex items-center justify-center hover:bg-transparent transition-all">
            <svg viewBox="0 0 80 80" width="100%" height="100%" preserveAspectRatio="xMidYMid meet"
              xmlns="http://www.w3.org/2000/svg">
              <!-- Outer circle -->
              <circle cx="40" cy="40" r="34" stroke="white" stroke-width="4" fill="none" />

              <!-- Play triangle -->
              <polygon points="34,28 34,52 52,40" fill="none" stroke="white" stroke-width="4" stroke-linejoin="round"
                stroke-linecap="round" />
            </svg>
          </div>
        </div>
      </div>

      <!-- Text -->
      <div class="flex flex-col sm:flex-col">
        <h3 class="text-base text-sm sm:text-xl font-medium text-Neutrals-Black leading-snug">
          {{ item?.title }}
        </h3>
        <p class="text-xs sm:text-sm text-[#777777] font-medium">
          {{ item?.created_date | date }}
          <span *ngIf="item?.author_name">, {{ item?.author_name }}</span>
        </p>
      </div>
    </div>
  </div>

  <!-- Empty State -->
  <div class="container mx-auto px-4 sm:px-6 py-16 text-center" *ngIf="filteredItems.length === 0">
    <p class="text-gray-500 text-base sm:text-lg">No items found.</p>
  </div>

  <!-- Pagination Controls -->
  <div class="w-full flex justify-center items-center gap-2 py-10 mt-6"
    *ngIf="totalPages > 1 && filteredItems.length > 0">
    <app-pagination [currentPage]="currentPage" [totalPages]="totalPages" [isVisible]="totalPages > 1"
      (pageChange)="handlePageChange($event)">
    </app-pagination>
  </div>

  <!-- Video Modal -->
  <div *ngIf="isVideoModalOpen" class="fixed inset-0 z-[100] flex items-center justify-center bg-black/85 p-3 sm:p-4"
    role="dialog" aria-modal="true" (click)="closeVideoModal()">
    <div class="relative w-full max-w-4xl" (click)="$event.stopPropagation()">
      <!-- Close button -->
      <button type="button"
        class="absolute -top-11 right-0 z-20 rounded-full bg-white/20 hover:bg-white/30 p-2 text-white transition-colors cursor-pointer"
        (click)="closeVideoModal()" aria-label="Close video">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M18 6L6 18M6 6L18 18" />
        </svg>
      </button>

          Video Player with Click-to-Play/Pause -->
          <div
            class="aspect-video w-full overflow-hidden rounded-xl bg-black shadow-2xl relative cursor-pointer select-none"
            (click)="togglePlayPause()" role="button" tabindex="0"
            (keydown.space)="togglePlayPause(); $event.preventDefault()">
            <iframe *ngIf="currentVideoUrl" id="youtubeVideoIframe" class="h-full w-full block pointer-events-none"
              style="border: 0;" [src]="currentVideoUrl" [attr.title]="currentVideoTitle"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen"
              allowfullscreen></iframe>

            <!-- Center Play/Pause indicator -->
            <div class="absolute inset-0 flex items-center justify-center pointer-events-none">
              <div *ngIf="!isVideoPlaying || showIndicator"
                class="w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-black/60 backdrop-blur-sm flex items-center justify-center text-white transition-all duration-200 shadow-xl">
                <!-- Pause Icon (when briefly flashing on pause) -->
                <svg *ngIf="isVideoPlaying" width="30" height="30" viewBox="0 0 24 24" fill="currentColor">
                  <rect x="6" y="4" width="4" height="16" rx="1" />
                  <rect x="14" y="4" width="4" height="16" rx="1" />
                </svg>
                <!-- Play Icon (when video is paused) -->
                <svg *ngIf="!isVideoPlaying" width="34" height="34" viewBox="0 0 24 24" fill="currentColor"
                  class="ml-1">
                  <polygon points="5,3 19,12 5,21" />
                </svg>
              </div>
            </div>
          </div>

          <!-- Video title -->
          <h3 class="mt-3 px-1 text-base text-white sm:mt-4 sm:text-xl font-medium">
            {{ currentVideoTitle }}
          </h3>
      </div>
    </div>
  </div>